import type { ReactNode } from 'react';
import styled from 'styled-components';

type Props = {
  label: ReactNode;
  values: TooltipValue[];
};

type TooltipValue = {
  fill: string;
  value: ReactNode;
};

const TooltipContent = ({ label, values }: Props): ReactNode => {
  return (
    <StyledTooltipContainer>
      {values.length > 1 && <div>{label}</div>}
      <StyledTooltipContent>
        {values.map((value: TooltipValue, index: number): ReactNode => {
          return (
            <StyledTooltipItem key={index}>
              <div
                style={{
                  width: 3,
                  borderRadius: 2,
                  background: value.fill,
                }}
              ></div>
              <div>
                {values.length === 1 && <div>{label}</div>}
                <div>{value.value}</div>
              </div>
            </StyledTooltipItem>
          );
        })}
      </StyledTooltipContent>
    </StyledTooltipContainer>
  );
};

const StyledTooltipContainer = styled.div`
  background: #fffffff7;
  box-shadow: 4px 4px 15px 0 #0001;
  border: none;
  border-radius: 3px;
  padding: 4px 8px;
  font-size: 12px;
`;
const StyledTooltipContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const StyledTooltipItem = styled.div`
  display: flex;
  gap: 8px;
`;

export { TooltipContent };
